<template>
  <div class="cart cart-standalone flex--column">
    <div class="cart__header header">
      <h2 class="header__title">{{ $t('cart.title') }} ({{ cartProductsCount }})</h2>
      <p v-if="isCartEmpty" class="header__empty-cart-message">
        {{ $t('cart.emptyCartMessage') }}
      </p>
    </div>

    <vue-perfect-scrollbar class="cart-standalone__content cart__content cart-content">
      <delivery-notification
        :has-free-delivery="hasFreeDelivery"
        :free-delivery-message="freeDeliveryMessage"
        :free-delivery-status="freeDeliveryStatus"
        class="cart-content__delivery-notification"
      />

      <product-list class="cart__product-list" has-notification />
      <cart-footer v-if="!isCartEmpty" class="cart__footer" />
      <cart-checkout-bar
        v-if="!isCartEmpty"
        class="cart-standalone__checkout-bar"
        :is-checkout-button-disabled="isCartEmpty"
      />
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

import ProductList from '@/components/cart/ProductList.vue';
import CartFooter from '@/components/cart/CartFooter.vue';
import CartCheckoutBar from '@/components/cart/CartCheckoutBar.vue';
import DeliveryNotification from '@/components/cart/DeliveryNotification.vue';

import { priceFormatterMixin } from '@/mixins/priceFormatterMixin';
import { displayNameMixin } from '@/mixins/displayNameMixin';

import { types } from '@/store/types';
import { ICON, ICON_VALUE } from '@/constants/icons';

export default {
  name: 'CartStandalone',
  components: {
    ProductList,
    CartFooter,
    CartCheckoutBar,
    VuePerfectScrollbar,
    DeliveryNotification
  },
  mixins: [priceFormatterMixin, displayNameMixin],
  boxIcon: ICON_VALUE[ICON.BOX],
  computed: {
    ...mapGetters({
      hasFreeDelivery: types.getters.HAS_FREE_DELIVERY,
      freeDeliveryMessageConfig: types.getters.FREE_DELIVERY_MESSAGE_CONFIG,
      deliveryCountry: types.getters.DELIVERY_COUNTRY,
      cartProductsCount: types.getters.CART_PRODUCTS_COUNT
    }),
    isCartEmpty() {
      return this.cartProductsCount === 0;
    },
    freeDeliveryStatus() {
      const countryLabel = this.getCountryDisplayName(this.deliveryCountry);

      return this.hasFreeDelivery
        ? this.$t('checkout.freeDeliveryTo', { country: countryLabel })
        : this.$t('checkout.freeDeliveryAvailableTo', { country: countryLabel });
    },
    freeDeliveryMessage() {
      if (this.hasFreeDelivery) {
        return '';
      }

      const { messageKey, deliveryData } = this.freeDeliveryMessageConfig;
      const { residue, deliveryCountry } = deliveryData;
      const residueFormatted = this.formatPrice(residue);
      const countryLabel = this.getCountryDisplayName(deliveryCountry);

      return this.$t(messageKey, [residueFormatted, countryLabel]);
    }
  },
  mounted() {
    this.fetchStockInfo();
  },
  methods: {
    ...mapActions({
      fetchStockInfo: types.actions.FETCH_STOCK_INFO
    })
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/colors.scss';
@import '../../assets/scss/cart.scss';
@import '../../assets/scss/icon.scss';

.cart-standalone {
  position: relative;
  background-color: $seashell-peach-color;
  height: var(--screen-height);

  &__checkout-bar {
    width: 100%;
  }

  &__content {
    padding: 0 16px;
  }
}

.cart-content {
  &__delivery-notification {
    padding: 14px 0;
    border-bottom: 1px solid $timberwolf-color;
  }
}

@media (min-width: 600px) {
  .cart-standalone {
    &__content {
      padding: 0 56px;
    }
  }
}
</style>
